import React from "react";

import { Button, Stack, Tooltip } from "@mui/material";

export interface ControlButtonProps {
  children?: React.ReactNode;
  disabled?: boolean;
  active: boolean;
  activeLabel: string;
  inactiveLabel: string;
  activeColor?: string;
  activeIcon?: React.ReactNode;
  inactiveIcon?: React.ReactNode;
  showText?: boolean;
  fullWidth?: boolean;
  onClick: (active: boolean) => void;
}

export const ControlButton: React.FC<React.PropsWithChildren<ControlButtonProps>> = ({
  activeIcon,
  inactiveIcon,
  children,
  active,
  activeLabel,
  inactiveLabel,
  showText,
  disabled = false,
  activeColor = "lightgreen",
  fullWidth = false,
  onClick,
}) => {
  const tooltip = active ? activeLabel : inactiveLabel

  const icon = active ? activeIcon : inactiveIcon;
  const label = active ? activeLabel : inactiveLabel;

  let color = active ? activeColor : "lightgray";

  if (disabled) {
    color = "#979797";
  }

  return (
    <Tooltip title={tooltip}>
      <Stack
        direction="row"
        sx={{
          borderRadius: 1,
          boxShadow: 1,
          backgroundColor: color,
          alignItems: "center",
          width: fullWidth ? "100%" : "auto",
        }}
      >
        <Button
          disabled={disabled}
          onClick={() => onClick(!active)}
          aria-label={label}
          sx={{
            color: "black",
            fontWeight: 600,
            fontSize: "1.25rem",
            lineHeight: 1.4,
            height: "100%",
            width: "100%",
            justifyContent: showText ? "left" : "center",
            padding: 1,
          }}
        >
          {icon}
          {showText ? label : null}
        </Button>
        {children}
      </Stack>
    </Tooltip>
  );
};

export default ControlButton;
